<template>
  <div class="view-profile py-5 container">
    <h3>Meu Perfil</h3>
    <p class="text-secondary">Veja os detalhes e gerencie o seu perfil.</p>

    <h4 class="mb-4 mt-5">Dados pessoais</h4>
    <div class="card">
      <div class="card-body d-flex">
        <div class="flex-fill">
          <h5>{{ $user.user.name }}</h5>
          <div class="text-secondary">{{ $user.user.email }}</div>
          <div class="text-secondary">{{ $user.user.phone }}</div>
        </div>

        <router-link class="btn btn-link" :to="{ name: 'account' }">
          Editar
        </router-link>
      </div>
    </div>

    <h4 class="mb-4 mt-5">Meu Plano</h4>
    <div class="card">
      <div v-if="$user.user.plan" class="card-body d-flex">
        <img class="image-card mr-3" :src="$user.user.cof.cover" />

        <div class="flex-fill">
          <h5>
            Assinatura: {{ $user.user.plan.name }} - R$
            {{ $user.user.plan.price_card }}
          </h5>
          <div class="text-secondary">Próxima renovação em {{ newCharge }}</div>
          <div v-if="$user.hasCof" class="text-secondary">
            Status: Plano Ativo
          </div>
          <div v-else class="text-secondary">Status: Plano Cancelado</div>
        </div>

        <router-link class="btn btn-link" :to="{ name: 'plan-change' }">
          Gerenciar
        </router-link>
      </div>

      <div v-else class="text-center py-4">
        <em class="text-secondary">Nenhuma assinatura</em>
      </div>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  data() {
    return {
      loading: false,
      ...formFields(["name", "phone", "email"], {
        ...this.$user.user,
        ...this.$courses
      })
    };
  },
  computed: {
    newCharge() {
      var data = new Date(this.$user.user.last_transaction.created_at);
      if (this.$user.user.plan["interval"] == "month") {
        data.setMonth(
          data.getMonth() + 1 * this.$user.user.plan["subscription_period"]
        );
        return data.toLocaleDateString();
      } else {
        data.setMonth(
          data.getMonth() + 12 * this.$user.user.plan["subscription_period"]
        );
        return data.toLocaleDateString();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.image-card {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100px;
  height: 100px;
  border-radius: 4px;
}
</style>
